import get from 'lodash/get';
import { j as COOKIE_STOP_REDIRECT } from '../cookies-l-jEMp6P.js';
import { C as CATEGORY } from '../paths-ZKN3m62_.js';
import { G as GetCategoryBanner } from '../GetCategoryBanner-6p0nM8yz.js';
import { G as GetCategory, a as GetScandiCategory, b as GetCategoryYmals } from '../GetCategoryYmals-iaGgJ2fD.js';
import { U as UrlResolver } from '../UrlResolver-yh_X8hA9.js';
import { p as publicQuery } from '../requestsCollection-_VRM28HJ.js';
import { ResolvedItemType } from '../types/index.js';
import '../checkout-Ee1eEXQH.js';
import '../menu-0TyOg98i.js';
import { P as ProductColorAttributeCode } from '../product-_pRduMz7.js';
import '../modal-6vnX5SO3.js';
import { getCookie } from './cookies.js';
import { extractErrorMessage } from './error.js';
import '../graphqlRequestClient-3KYHZKVm.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../services/auth/index.js';
import './logToSlack.js';
import './currency.js';
import '../currency-_kacFJHO.js';
import '../context/index.js';
import '../language-BHHwgtQp.js';
import '../payment-YC9H491Y.js';
import 'next/server';
import '../index-Oip0gjfj.js';
import 'next/router';
import '../helpers-kA_hdoOI.js';
import './product.js';
import 'cookies-next';
import 'lodash';
import './fetchPolicyLookup.js';
import './isBot.js';
import '../serverErrors-_VHsjhgw.js';
import './logger.js';
import './logToRelic.js';

const getCategoryLink = (path, locale) => {
    const formattedPath = String(path).replace(/^\//, ''); // remove first "/" symbol if exists
    const url = CATEGORY.replace('[...path]', formattedPath);
    return locale ? `/${locale}${url}` : url;
};
const getCategoryID = (category) => { var _a; return category && category.name_en ? (_a = category.name_en.category_name) === null || _a === void 0 ? void 0 : _a.replace(/ /g, '') : ''; };
const processCategoryItems = (scandiCategoryItems, category) => {
    const result = {
        items: [],
        isScandiCategoryItemsUsed: true,
    };
    if (scandiCategoryItems.length) {
        result.items = scandiCategoryItems.map(item => {
            if (!item.product_data) {
                return item;
            }
            const baseProduct = category.products.items.find(product => product.sku === item.product_data.sku);
            if (!baseProduct)
                return item;
            return {
                ...item,
                product_data: {
                    ...item.product_data,
                    name_en: baseProduct === null || baseProduct === void 0 ? void 0 : baseProduct.name_en,
                    categories: baseProduct.categories,
                },
            };
        });
        return result;
    }
    // Use default category request items (non-ordered)
    const categoryChild = get(category, 'children', []);
    const categoryProducts = get(category, ['products', 'items'], []);
    result.items = [
        ...categoryChild.map(item => ({
            category_data: item,
            product_data: null,
        })),
        ...categoryProducts.map(item => ({
            category_data: null,
            product_data: item,
        })),
    ];
    result.isScandiCategoryItemsUsed = false;
    return result;
};
const getCategory = async (apolloConfig, url, ctx) => {
    const result = {
        category: null,
        banner: null,
        categoryItems: [],
        redirectUrl: null,
        isScandiCategoryItemsUsed: false,
        error: null,
        notFound: false,
    };
    const { locale } = ctx;
    try {
        const resolvedCategory = await publicQuery(apolloConfig(ctx.locale), {
            query: UrlResolver,
            variables: {
                url,
            },
        }, 'UrlResolver', ctx).then(res => res.data.urlResolver);
        const resolvedItemType = resolvedCategory === null || resolvedCategory === void 0 ? void 0 : resolvedCategory.type;
        const resolvedCategoryId = resolvedCategory === null || resolvedCategory === void 0 ? void 0 : resolvedCategory.id;
        const resolvedCategoryUrl = resolvedCategory === null || resolvedCategory === void 0 ? void 0 : resolvedCategory.relative_url;
        const stopRedirectCookie = getCookie(COOKIE_STOP_REDIRECT);
        const englishUrlKey = resolvedCategory === null || resolvedCategory === void 0 ? void 0 : resolvedCategory.language_urls.url_en;
        const scandiCategoryUrl = (englishUrlKey === null || englishUrlKey === void 0 ? void 0 : englishUrlKey.split('/').pop()) || (url === null || url === void 0 ? void 0 : url.split('/').pop()) || null;
        if (resolvedItemType !== ResolvedItemType.Category || !resolvedCategoryId) {
            result.error = 'Category was not found';
            result.notFound = true;
            return result;
        }
        if (stopRedirectCookie) {
            return result;
        }
        if (resolvedItemType !== ResolvedItemType.Category || !resolvedCategoryId) {
            result.error = 'Category was not found';
            result.notFound = true;
            return result;
        }
        // If current "categoryUrl" and response "categoryUrl" are differ -
        // make a redirect to a new "categoryUrl"
        if (resolvedCategoryUrl && resolvedCategoryUrl !== url) {
            result.redirectUrl = resolvedCategoryUrl;
            return result;
        }
        const [categoryResponse, bannerResponse, scandiCategoryResponse] = await Promise.all([
            publicQuery(apolloConfig(ctx.locale), {
                query: GetCategory,
                variables: {
                    id: resolvedCategoryId,
                    productPageSize: 200,
                    locale,
                },
            }, 'GetCategory', ctx, true),
            publicQuery(apolloConfig(ctx.locale), {
                query: GetCategoryBanner,
                variables: {
                    id: resolvedCategoryId,
                    locale,
                },
            }, 'GetCategoryBanner', ctx),
            publicQuery(apolloConfig(ctx.locale), {
                query: GetScandiCategory,
                variables: {
                    categoryName: scandiCategoryUrl,
                    locale,
                },
            }, 'GetScandiCategory', ctx, true),
        ]);
        const categoryError = get(categoryResponse, ['errors', 0, 'message']);
        const bannerError = get(bannerResponse, ['errors', 0, 'message']);
        // we do not use a "scandiCategoryError" because
        // "GetScandiCategory" is an auxiliary endpoint
        // if a "GetCategory" is working - then this may be enough
        const error = categoryError || bannerError;
        if (error) {
            result.error = error;
            result.notFound = categoryError === "Category doesn't exist";
            return result;
        }
        const category = get(categoryResponse, ['data', 'category'], null);
        const banner = get(bannerResponse, ['data', 'banner', 0], null);
        const scandiCategoryItems = get(scandiCategoryResponse, ['data', 'scandiwebMenu', 'items'], []);
        if (!category) {
            result.error = 'Category was not found';
            result.notFound = true;
            return result;
        }
        const { items, isScandiCategoryItemsUsed } = processCategoryItems(scandiCategoryItems, category);
        result.category = category;
        result.banner = banner;
        result.categoryItems = items;
        result.isScandiCategoryItemsUsed = isScandiCategoryItemsUsed;
    }
    catch (e) {
        result.error = extractErrorMessage(e);
    }
    return result;
};
const getCategoryYmals = async (apolloConfig, categoryId, ctx) => {
    try {
        const response = await publicQuery(apolloConfig(ctx.locale), {
            query: GetCategoryYmals,
            variables: {
                id: categoryId,
            },
        }, 'GetCategoryYmals', ctx, true);
        return get(response, ['data', 'category', 'related_products_category'], []);
    }
    catch (e) {
        return [];
    }
};
const getCategoryProductImagesByColor = (product, color) => {
    const data = {
        imgUrl: '',
        imgUrlThumbnail: '',
        imgUrlHover: '',
    };
    const variantItem = product === null || product === void 0 ? void 0 : product.variants.find(variant => Boolean(variant.attributes.find(attribute => attribute.label === color)));
    if (!variantItem)
        return data;
    data.imgUrl = get(variantItem, 'product.small_image.url');
    data.imgUrlThumbnail = get(variantItem, 'product.thumbnail.url');
    data.imgUrlHover = get(variantItem, 'product.hover_image.url');
    return data;
};
const getColorSwitcherData = (product) => {
    var _a;
    const colorAttribute = (_a = product.configurable_options) === null || _a === void 0 ? void 0 : _a.find(option => Object.values(ProductColorAttributeCode).includes(option.attribute_code));
    const colors = ((colorAttribute === null || colorAttribute === void 0 ? void 0 : colorAttribute.values) || []).map(item => item.label);
    const images = colors.map(color => getCategoryProductImagesByColor(product, color));
    return {
        colors,
        images,
    };
};

export { getCategory, getCategoryID, getCategoryLink, getCategoryYmals, getColorSwitcherData };
//# sourceMappingURL=category.js.map
